export default __webpack_public_path__ + "static/media/comingsoon-bg.00fac4ff.jpg";